import { Drawer as AntDrawer } from "antd";
import React from "react";

import { Branch } from "~/Branch";
import * as Color from "~/Color";
import * as Log from "~/Log";

import * as Form from "./index";

export type DrawerProps = Drawer.Control & Partial<Branch>;

export function Drawer({
  isVisible,
  route,
  hide,
  branch,
  revision,
}: DrawerProps) {
  return revision ? (
    <AntDrawer
      title={"Suggested Revision"}
      placement="right"
      width={450}
      headerStyle={{ borderBottom: `1px sold ${Color.mist}` }}
      visible={isVisible}
      onClose={() => hide()}
    >
      <Form.Component
        branch={branch}
        route={route}
        revision={revision}
        onClose={() => hide()}
      />
    </AntDrawer>
  ) : null;
}

export namespace Drawer {
  export type Control = {
    readonly isVisible: boolean;
    readonly route: Log.Route;
    readonly revision?: Log.Event.Event | Log.Suggestion.Suggestion;
    readonly show: (
      revision?: Log.Event.Event | Log.Suggestion.Suggestion
    ) => void;
    readonly hide: () => void;
  };

  export const use = (route: Log.Route): Drawer.Control => {
    type DrawerControlState = {
      readonly isVisible: boolean;
      readonly route: Log.Route;
      readonly revision?: Log.Event.Event | Log.Suggestion.Suggestion;
    };
    const [drawerControl, updateDrawerControl] = React.useState<
      DrawerControlState
    >({
      isVisible: false,
      route,
      revision: undefined,
    });
    return {
      ...drawerControl,
      show: (revision) =>
        updateDrawerControl({ isVisible: true, route, revision }),
      hide: () =>
        updateDrawerControl({ isVisible: false, route, revision: undefined }),
    };
  };
}
